import { useState, useEffect } from "react";
import { STORAGE_CUENTAS } from "./FinanzasConfig";

const STORAGE_ASIENTOS = 'alqos_asientos';
const STORAGE_LINEAS = 'alqos_asientos_lineas';
const STORAGE_CXC = 'alqos_cxc_cxp';

function hoy() { return new Date().toISOString().slice(0, 10); }
function addDias(fechaISO, dias) {
  const d = new Date(fechaISO + 'T00:00:00');
  d.setDate(d.getDate() + dias);
  return d.toISOString().slice(0, 10);
}
const money = (n) => `$${Math.round(Number(n) || 0).toLocaleString('es-AR')}`;
const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

const COLOR_INGRESO = '#16a34a';
const COLOR_EGRESO = '#dc2626';

export default function Finanzas({ onVolver, oscuro, usuario, onNavegar }) {
  const [cuentas, setCuentas] = useState([]);
  const [asientos, setAsientos] = useState([]);
  const [lineas, setLineas] = useState([]);
  const [cxcCxp, setCxcCxp] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [hoverBar, setHoverBar] = useState(null);
  const [vistaTabla, setVistaTabla] = useState(false);

  useEffect(() => {
    const cargar = () => {
      try { setCuentas(JSON.parse(localStorage.getItem(STORAGE_CUENTAS) || '[]')); } catch {}
      try { setAsientos(JSON.parse(localStorage.getItem(STORAGE_ASIENTOS) || '[]')); } catch {}
      try { setLineas(JSON.parse(localStorage.getItem(STORAGE_LINEAS) || '[]')); } catch {}
      try { setCxcCxp(JSON.parse(localStorage.getItem(STORAGE_CXC) || '[]')); } catch {}
    };
    cargar();
    setCargando(false);
    window.addEventListener('supabase-sync-complete', cargar);
    return () => window.removeEventListener('supabase-sync-complete', cargar);
  }, []);

  const cuentasPorId = Object.fromEntries(cuentas.map(c => [c.id, c]));

  const saldoCaja = cuentas
    .filter(c => c.activo !== false && c.codigo?.startsWith('1.1.01'))
    .reduce((s, c) => s + (Number(c.saldo) || 0), 0);

  const totalCxC = cxcCxp
    .filter(i => i.tipo === 'cobrar' && i.estado !== 'pagado')
    .reduce((s, i) => s + (Number(i.montoPendiente) || 0), 0);

  const totalCxP = cxcCxp
    .filter(i => i.tipo === 'pagar' && i.estado !== 'pagado')
    .reduce((s, i) => s + (Number(i.montoPendiente) || 0), 0);

  // ── Últimos 6 meses: ingresos vs egresos (asientos confirmados) ──
  const hoyD = new Date();
  const meses6 = Array.from({ length: 6 }, (_, i) => {
    const d = new Date(hoyD.getFullYear(), hoyD.getMonth() - (5 - i), 1);
    return { anio: d.getFullYear(), mes: d.getMonth(), label: MESES[d.getMonth()] };
  });

  const datosMeses = meses6.map(({ anio, mes, label }) => {
    let ingresos = 0, egresos = 0;
    const asientosDelMes = asientos.filter(a => {
      if (a.estado !== 'confirmado' || !a.fecha) return false;
      const fa = new Date(a.fecha + 'T00:00:00');
      return fa.getFullYear() === anio && fa.getMonth() === mes;
    });
    const idsAsientos = new Set(asientosDelMes.map(a => a.id));
    lineas.filter(l => idsAsientos.has(l.asientoId)).forEach(l => {
      const c = cuentasPorId[l.cuentaId];
      if (!c) return;
      const debe = Number(l.debe) || 0, haber = Number(l.haber) || 0;
      if (c.tipo === 'ingreso') ingresos += (haber - debe);
      if (c.tipo === 'egreso') egresos += (debe - haber);
    });
    return { label, anio, mes, ingresos: Math.max(ingresos, 0), egresos: Math.max(egresos, 0) };
  });

  const mesActual = datosMeses[datosMeses.length - 1];
  const resultadoMes = (mesActual?.ingresos || 0) - (mesActual?.egresos || 0);

  const maxVal = Math.max(1, ...datosMeses.flatMap(m => [m.ingresos, m.egresos]));

  // ── CxC/CxP vencidas o por vencer en 7 días ──
  const limite7 = addDias(hoy(), 7);
  const alertasCxCxP = cxcCxp
    .filter(i => i.estado !== 'pagado' && i.fechaVencimiento)
    .filter(i => i.fechaVencimiento <= limite7)
    .map(i => ({ ...i, vencida: i.fechaVencimiento < hoy() }))
    .sort((a, b) => (a.fechaVencimiento || '').localeCompare(b.fechaVencimiento || ''));

  // ── SVG chart geometry ──
  const chartW = 640, chartH = 220, padL = 44, padB = 28, padT = 12;
  const plotW = chartW - padL - 16, plotH = chartH - padB - padT;
  const grupoW = plotW / datosMeses.length;
  const barW = 16, gapBarras = 3;

  const tarjeta = (icono, label, valor, color) => (
    <div style={{ background: 'white', borderRadius: '14px', border: '1px solid #E5E7EB', padding: '16px 18px', flex: 1, minWidth: '180px' }}>
      <div style={{ fontSize: '11px', fontWeight: '600', color: '#6B7280', marginBottom: '6px' }}>{icono} {label}</div>
      <div style={{ fontSize: '22px', fontWeight: '800', color: color || '#1C3FAA' }}>{money(valor)}</div>
    </div>
  );

  const btnAccion = (icono, label, modulo) => (
    <button
      onClick={() => onNavegar && onNavegar(modulo)}
      style={{ background: 'white', border: '1px solid #E5E7EB', borderRadius: '10px', padding: '10px 16px', fontSize: '12px', fontWeight: '600', color: '#1C3FAA', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
    >
      <span>{icono}</span> {label}
    </button>
  );

  if (cargando) return null;

  return (
    <div style={{ padding: '24px', fontFamily: 'Inter, sans-serif', background: '#E8E9F6', minHeight: '100vh' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <button onClick={onVolver} style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer', color: '#6B7280' }}>← Menú</button>
          <span style={{ fontSize: '22px' }}>💰</span>
          <h1 style={{ fontSize: '20px', fontWeight: '700', color: '#1C3FAA', margin: 0 }}>Finanzas</h1>
        </div>
      </div>

      {/* Accesos rápidos */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}>
        {btnAccion('📑', 'Nuevo Asiento', 'asientoscontables')}
        {btnAccion('💳', 'Cobros / Pagos', 'cxccxp')}
        {btnAccion('🏦', 'Movimientos de Caja', 'movimientoscaja')}
        {btnAccion('📒', 'Plan de Cuentas', 'plancuentas')}
        {btnAccion('📊', 'Balance', 'balancesimplificado')}
      </div>

      {/* Tarjetas resumen */}
      <div style={{ display: 'flex', gap: '12px', marginBottom: '20px', flexWrap: 'wrap' }}>
        {tarjeta('🏦', 'Saldo Caja y Bancos', saldoCaja, '#1C3FAA')}
        {tarjeta('💳', 'Total por Cobrar', totalCxC, '#16a34a')}
        {tarjeta('📄', 'Total por Pagar', totalCxP, '#dc2626')}
        {tarjeta('📈', 'Resultado del mes', resultadoMes, resultadoMes >= 0 ? '#16a34a' : '#dc2626')}
      </div>

      {/* Gráfico ingresos vs egresos */}
      <div style={{ background: 'white', borderRadius: '14px', border: '1px solid #E5E7EB', padding: '18px', marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
          <div style={{ fontSize: '13px', fontWeight: '700', color: '#111' }}>Ingresos vs Egresos — últimos 6 meses</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px', fontSize: '11px', color: '#6B7280' }}>
              <span><span style={{ display: 'inline-block', width: '10px', height: '10px', borderRadius: '2px', background: COLOR_INGRESO, marginRight: '5px' }}></span>Ingresos</span>
              <span><span style={{ display: 'inline-block', width: '10px', height: '10px', borderRadius: '2px', background: COLOR_EGRESO, marginRight: '5px' }}></span>Egresos</span>
            </div>
            <button onClick={() => setVistaTabla(v => !v)} style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: '6px', padding: '4px 10px', fontSize: '11px', cursor: 'pointer', color: '#6B7280' }}>
              {vistaTabla ? '📊 Ver gráfico' : '📋 Ver tabla'}
            </button>
          </div>
        </div>

        {vistaTabla ? (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
            <thead>
              <tr style={{ background: '#F9FAFB' }}>
                {['Mes', 'Ingresos', 'Egresos', 'Resultado'].map(h => (
                  <th key={h} style={{ padding: '8px 10px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#6B7280', borderBottom: '1px solid #E5E7EB' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {datosMeses.map((m, i) => (
                <tr key={i}>
                  <td style={{ padding: '8px 10px', borderBottom: '1px solid #F3F4F6' }}>{m.label} {m.anio}</td>
                  <td style={{ padding: '8px 10px', borderBottom: '1px solid #F3F4F6', color: COLOR_INGRESO, fontWeight: '600' }}>{money(m.ingresos)}</td>
                  <td style={{ padding: '8px 10px', borderBottom: '1px solid #F3F4F6', color: COLOR_EGRESO, fontWeight: '600' }}>{money(m.egresos)}</td>
                  <td style={{ padding: '8px 10px', borderBottom: '1px solid #F3F4F6', fontWeight: '700', color: (m.ingresos - m.egresos) >= 0 ? COLOR_INGRESO : COLOR_EGRESO }}>{money(m.ingresos - m.egresos)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <svg width="100%" viewBox={`0 0 ${chartW} ${chartH}`} style={{ overflow: 'visible' }}>
            {[0, 0.25, 0.5, 0.75, 1].map((f, i) => (
              <line key={i} x1={padL} x2={chartW - 16} y1={padT + plotH - f * plotH} y2={padT + plotH - f * plotH} stroke="#F3F4F6" strokeWidth="1" />
            ))}
            {[0, 0.5, 1].map((f, i) => (
              <text key={i} x={padL - 8} y={padT + plotH - f * plotH + 3} textAnchor="end" fontSize="9" fill="#9CA3AF">{money(maxVal * f)}</text>
            ))}
            {datosMeses.map((m, i) => {
              const x0 = padL + i * grupoW + grupoW / 2 - (barW + gapBarras / 2);
              const hIng = (m.ingresos / maxVal) * plotH;
              const hEgr = (m.egresos / maxVal) * plotH;
              const yIng = padT + plotH - hIng;
              const yEgr = padT + plotH - hEgr;
              return (
                <g key={i}>
                  <rect x={x0} y={yIng} width={barW} height={Math.max(hIng, 1)} rx="4" fill={COLOR_INGRESO}
                    opacity={hoverBar && hoverBar.i === i ? 1 : 0.9}
                    onMouseEnter={() => setHoverBar({ i, tipo: 'ingresos' })} onMouseLeave={() => setHoverBar(null)} />
                  <rect x={x0 + barW + gapBarras} y={yEgr} width={barW} height={Math.max(hEgr, 1)} rx="4" fill={COLOR_EGRESO}
                    opacity={hoverBar && hoverBar.i === i ? 1 : 0.9}
                    onMouseEnter={() => setHoverBar({ i, tipo: 'egresos' })} onMouseLeave={() => setHoverBar(null)} />
                  <text x={padL + i * grupoW + grupoW / 2} y={chartH - 8} textAnchor="middle" fontSize="10" fill="#6B7280">{m.label}</text>
                </g>
              );
            })}
            {hoverBar && (() => {
              const m = datosMeses[hoverBar.i];
              const val = hoverBar.tipo === 'ingresos' ? m.ingresos : m.egresos;
              const color = hoverBar.tipo === 'ingresos' ? COLOR_INGRESO : COLOR_EGRESO;
              const x = padL + hoverBar.i * grupoW + grupoW / 2;
              return (
                <g pointerEvents="none">
                  <rect x={x - 46} y={padT - 4} width="92" height="20" rx="5" fill="#111827" opacity="0.92" />
                  <text x={x} y={padT + 10} textAnchor="middle" fontSize="10" fill="white" fontWeight="700">{m.label}: <tspan fill={color}>{money(val)}</tspan></text>
                </g>
              );
            })()}
          </svg>
        )}
      </div>

      {/* CxC/CxP vencidas o próximas a vencer */}
      <div style={{ background: 'white', borderRadius: '14px', border: '1px solid #E5E7EB', overflow: 'hidden' }}>
        <div style={{ padding: '14px 18px', borderBottom: '1px solid #E5E7EB', fontSize: '13px', fontWeight: '700', color: '#111' }}>
          Vencidas y por vencer (próximos 7 días)
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#F9FAFB' }}>
              {['Tipo', 'Entidad', 'Vencimiento', 'Monto pendiente', 'Estado'].map(h => (
                <th key={h} style={{ padding: '10px 14px', fontSize: '11px', fontWeight: '600', color: '#6B7280', textAlign: 'left', borderBottom: '1px solid #E5E7EB' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {alertasCxCxP.length === 0 ? (
              <tr><td colSpan={5} style={{ padding: '40px', textAlign: 'center', color: '#9CA3AF', fontSize: '12px' }}>Sin vencimientos próximos</td></tr>
            ) : alertasCxCxP.map(i => (
              <tr key={i.id}>
                <td style={{ padding: '10px 14px', borderBottom: '1px solid #F3F4F6', fontSize: '12px' }}>
                  <span style={{ background: i.tipo === 'cobrar' ? '#16a34a18' : '#dc262618', color: i.tipo === 'cobrar' ? '#16a34a' : '#dc2626', fontSize: '11px', padding: '2px 8px', borderRadius: '6px', fontWeight: '600' }}>
                    {i.tipo === 'cobrar' ? 'Por Cobrar' : 'Por Pagar'}
                  </span>
                </td>
                <td style={{ padding: '10px 14px', borderBottom: '1px solid #F3F4F6', fontSize: '12px' }}>{i.entidadNombre || '—'}</td>
                <td style={{ padding: '10px 14px', borderBottom: '1px solid #F3F4F6', fontSize: '12px' }}>{i.fechaVencimiento}</td>
                <td style={{ padding: '10px 14px', borderBottom: '1px solid #F3F4F6', fontSize: '12px', fontWeight: '600' }}>{money(i.montoPendiente)}</td>
                <td style={{ padding: '10px 14px', borderBottom: '1px solid #F3F4F6' }}>
                  <span style={{ background: i.vencida ? '#dc262618' : '#d9770618', color: i.vencida ? '#dc2626' : '#d97706', fontSize: '11px', padding: '2px 8px', borderRadius: '6px', fontWeight: '600' }}>
                    {i.vencida ? 'Vencida' : 'Por vencer'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
